import PreservedLink from '@/components/shared/PreservedLink'

export function KeyInformation({ className = '' }) {
  return (
    <section
      className={`py-12 md:py-16 ${className}`}
      style={{ backgroundColor: 'rgba(25, 135, 84, 0.1)' }}
    >
      <div className="container mx-auto max-w-6xl px-4">
        <h2
          className="mb-8 text-2xl font-bold"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          Key Information
        </h2>

        <div className="space-y-8">
          {/* Average Refund Value */}
          <div>
            <h4
              className="font-raleway-numbers mb-3 text-lg font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Average £2,086 per household
              <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>1</sup>
            </h4>
            <p
              className="font-raleway-numbers text-sm leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Household refund values are based on data published by the Office
              for National Statistics (ONS) and the Financial Conduct Authority
              (FCA), together with analysis of vehicle finance agreements
              identified through our process. Calculations assume 2 adults per
              household and 3.4 vehicle finance agreements per person. FCA data
              indicates average compensation of £829 per agreement and that 37%
              of agreements may be affected. Eligibility and compensation will
              vary and are not guaranteed.
            </p>
          </div>

          {/* FCA motor finance update */}
          <div>
            <h4
              className="mb-3 text-lg font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              FCA motor finance update
              <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>2</sup>
            </h4>
            <p
              className="font-raleway-numbers text-sm leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              As a result of its review of the motor finance industry, the FCA
              announced a consumer redress scheme in March 2026. The scheme is
              currently subject to legal challenge. This does not affect our
              claims process, and we will continue to keep our customers
              informed of further developments.
            </p>
          </div>

          {/* No Win No Fee */}
          <div>
            <h4
              className="mb-3 text-lg font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              No Win No Fee
              <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>3</sup>
            </h4>
            <p
              className="font-raleway-numbers text-sm leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              We will run a free vehicle finance check. If we find you may be
              eligible, we will refer your claim(s) to our law firm partner My
              Law Matters (MLM). We will let you know before we do this. MLM
              will submit eligible claims to your lender(s) on a no win no fee
              basis. If successful, MLM&apos;s fee is between 15% to 30% + VAT
              (18% to 36% total) of the amount recovered. MLM may charge a fee
              if you cancel after the 14-day cooling off period, this will be
              explained in their documentation which we will send to you. MLM
              pay Claims1 a referral fee for claims referred, this is not
              payable by you.
            </p>
          </div>

          {/* Information Sources */}
          <div>
            <h4
              className="mb-3 text-lg font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Information Sources
              <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>4</sup>
            </h4>
            <p
              className="font-raleway-numbers text-sm leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              The FCA have estimated that individual claims will be worth an
              average of £829. For detailed information regarding potential
              claim values and the FCA&apos;s estimate of the number of vehicle
              finance agreements that were mis-sold, please refer to{' '}
              <a
                href="https://www.fca.org.uk/news/statements/fca-consults-motor-finance-compensation-scheme"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                https://www.fca.org.uk/news/statements/fca-consults-motor-finance-compensation-scheme
              </a>{' '}
              and{' '}
              <a
                href="https://www.fca.org.uk/publication/policy/ps26-3.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                https://www.fca.org.uk/publication/policy/ps26-3.pdf (page 12)
              </a>
            </p>
          </div>

          {/* About Your Choices */}
          <div>
            <h4
              className="mb-3 text-lg font-bold"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Alternative Ways To Claim
            </h4>
            <p
              className="text-sm leading-relaxed"
              style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
            >
              Please be aware that you can make a free motor finance mis-selling
              claim directly with your lender, through the FCA redress scheme,
              or via the Financial Ombudsman Service. We can do the work for
              you, but you do not need to use a claims management company or law
              firm to make a claim. See Claims1{' '}
              <PreservedLink
                to="/terms-and-conditions"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Terms & Conditions
              </PreservedLink>{' '}
              and{' '}
              <PreservedLink
                to="/mlm-information-and-key-facts"
                className="text-blue-600 underline hover:text-blue-800"
              >
                Key Facts
              </PreservedLink>{' '}
              for full details including all fees applicable on payout of your
              claim.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default KeyInformation
